import React from 'react';
import { useTranslation } from 'react-i18next';
import { DETAILS_CARD } from '@/components/LessonDetailsModal/classNames';

interface Props {
  title: string;
  evaluation: string;
  points: string;
  percentage?: string;
  isEvaluationBadge?: boolean;
}

export const TestScoreCard: React.FC<Props> = ({
  title,
  evaluation,
  points,
  percentage,
  isEvaluationBadge = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`flex flex-col gap-3 ${DETAILS_CARD}`}>
      <div className="text-subhead-14 flex items-center justify-between gap-3 text-foreground">
        <span>{title}</span>
        {isEvaluationBadge && (
          <span className="flex h-6 min-w-6 items-center justify-center rounded-xl bg-highlight-lightblue px-2">
            {evaluation}
          </span>
        )}
        {!isEvaluationBadge && <span>{evaluation}</span>}
      </div>
      <div className="text-body-14 flex justify-between gap-3 text-muted-foreground">
        <span>{t('diary.testReport.points')}</span>
        <span>{points}</span>
      </div>
      {!!percentage && (
        <div className="text-body-14 flex justify-between gap-3 text-muted-foreground">
          <span>{t('diary.testReport.percentage')}</span>
          <span>{percentage}</span>
        </div>
      )}
    </div>
  );
};
